import ApiService from '../../../../services/ApiService'
import InstitutionInactive from '../../Institutions/components/institutionInactive/institutionInactive'
import CustomizeQRCode from './components/customizeQrCode.vue'

export default {
  components: {
    InstitutionInactive,
    CustomizeQRCode,
  },

  data: () => ({
    userId: null,
    editLoading: false,
    currentSubDepartment: {},
    editSubdepartmentKey: false,
    editSubdepartmentDialog: false,
    addDialog: false,
    active: true,
    unidades: [],
    unidadeId: null,
    isEditing: false,
    applyRules: true,
    alterDialog: false,
    changedData: false,
    confirmDialog: false,
    deleteDialog: false,
    loading: false,
    departmentLoading: false,
    deleteLoading: false,
    showSuccess: false,
    error: false,
    status: true,
    institutionInactive: false,
    errorMessage: '',
    message: '',
    institutionId: null,
    departmentId: 0,
    departments: [],
    departmentName: null,
    currentDepartment: {
      unidadeId: null,
      id: 0,
      name: '',
      initials: '',
      subDepartments: [],
      status: 0,
      costCenter: {
        id: 0,
        name: '',
        initials: '',
      },
    },

    deletedDepartment: null,
    file: null,
    apiService: new ApiService(),
    newDepartment: {
      id: null,
      Name: null,
      initials: null,
      unidadeId: null,
      subDepartments: [],
      status: 0,
    },

    customizeDialog: false,
    showFilters: false,
    exportMenu: [
      {
        icon: 'mdi-microsoft-excel',
        title: 'Excel',
        action: 'excel',
        access: [0, 1, 2, 3],
      },
      {
        icon: 'mdi-qrcode',
        title: 'QRCode',
        options: [
          {
            title: 'Customizar QRCODE',
            action: 'qrcode-customize',
            icon: 'mdi-circle-edit-outline',
          },

          {
            title: 'QRCode Etiqueta',
            action: 'qrcode',
            icon: 'mdi-ticket',
          },

          {
            title: 'QRCode Excel',
            action: 'qrcodeXlsx',
            icon: 'mdi-microsoft-excel',
          },
        ],
        access: [0, 1, 2, 3],
      },
    ],
  }),

  async created() {
    const institution = JSON.parse(localStorage.getItem('institution'))
    const user = JSON.parse(localStorage.getItem('user'))

    this.institutionId = institution.id
    this.institutionInactive = institution.status == 1

    this.userId = user.id

    this.searchDepartment()
    this.getUnidades()
  },

  methods: {
    openEdit(subDepartment) {
      this.currentSubDepartment = subDepartment
      this.editSubdepartmentKey = !this.editSubdepartmentKey
      this.editSubdepartmentDialog = true
    },

    menuExportActionClick(action) {
      console.log(action)

      switch (action) {
        case 'qrcode':
          this.openExportQrCode()
          break
        case 'qrcodeXlsx':
          this.gerenarateQrCodeExcel()
          break
        case 'excel':
          this.searchDepartmentExcel()
          break
      }
    },

    menuChildExport(action) {
      switch (action) {
        case 'qrcode-customize':
          this.openCustomizeQR()
          break
        case 'qrcode':
          this.openExportQrCode()
          break
        case 'qrcodeXlsx':
          this.gerenarateQrCodeExcel()
          break
      }
    },

    openCustomizeQR() {
      this.customizeDialog = true
    },

    async gerenarateQrCodeExcel() {
      const filter = {
        departmentName: this.departmentName,
        active: this.active,
        unityId: this.unidadeId,
        baseUrl: window.location.origin + '/newCalled',
        institutionId: this.institutionId,
      }

      this.printDialog = true
      const fileName = `QrCodeList.xlsx`

      await this.apiService
        .post('department/get-qrcodes/excel', filter)
        .then((response) => {
          var excelResult = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = excelResult
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          this.printDialog = false
        })
    },

    openExportQrCode() {
      const filter = {
        departmentName: this.departmentName,
        active: this.active,
        unityId: this.unidadeId,
        institutionId: this.institutionId,
      }
      this.filter = sessionStorage.setItem(
        'departmentFilters',
        JSON.stringify(filter)
      )

      this.$router.push({
        name: 'sectorExportQrcode',
        params: { filter: filter },
      })
    },

    addDepartmentDialog() {
      this.newDepartment = {
        Name: null,
        initials: null,
        unidadeId: null,
        subDepartments: [],
      }
      this.addDialog = true
    },

    editDepartment(i) {
      this.isEditing = true
      this.institutionId, (this.newDepartment.id = i.id)
      this.newDepartment.unidadeId = i.unidadeId
      this.newDepartment.name = i.name
      this.newDepartment.initials = i.initials
      this.newDepartment.subDepartments = i.subDepartments
      this.newDepartment.status = i.status
      this.addDialog = true
    },

    editSubdepartment() {
      if (this.$refs.subdepForm.validate()) {
        this.editLoading = true

        this.apiService
          .post('department/subdepartment/edit', this.currentSubDepartment)
          .then((response) => {
            this.$toast.success('Sub-setor adicionado com sucesso')
            this.editSubdepartmentDialog = false
            this.editLoading = false
            this.searchDepartment()
          })
          .catch(() => {
            this.editLoading = false
          })
      }
    },

    newSubDepartment(index) {
      const subDepartment = this.newDepartment.subDepartments[index]
      subDepartment.departmentId = this.newDepartment.id

      this.apiService
        .post('department/subdepartment/add', subDepartment)
        .then((response) => {
          this.$toast.success('Sub-setor adicionado com sucesso')
          this.newDepartment.subDepartments.pop()
          this.newDepartment.subDepartments.push(response.content)
        })
    },

    sendSubdepartment(index) {
      const subDepartment = this.currentDepartment.subDepartments[index]
      subDepartment.departmentId = this.currentDepartment.id

      if (!subDepartment.name) {
        this.$toast.warning('Insira o nome do setor')
        return
      }

      this.apiService
        .post('department/subdepartment/add', subDepartment)
        .then((response) => {
          this.$toast.success('Sub-setor adicionado com sucesso')
          this.currentDepartment.subDepartments.pop()
          this.currentDepartment.subDepartments.push(response.content)
        })
    },

    addSubDepartment(i) {
      this.currentDepartment = this.departments[i]
      this.currentDepartment.subDepartments.push({
        name: '',
      })
    },

    removeNewSubDepartment(index) {
      const subDepartment = this.newDepartment.subDepartments[index]
      this.newDepartment.subDepartments.splice(index, 1)

      if (subDepartment.id)
        this.apiService
          .delete(`department/subdepartment/delete/${subDepartment.id}`)
          .then(() => {
            this.searchDepartment()
          })
    },

    addNewSubDepartment() {
      const notAdded = this.newDepartment.subDepartments.find((x) => !x.id)

      if (notAdded) {
        this.$toast.warning('Atenção! Adicione um sub-setor por vez!')
        return
      }

      this.newDepartment.subDepartments.push({
        name: '',
      })
    },

    removeSubDepartment(index, i) {
      this.currentDepartment = this.departments[i]
      if (this.currentDepartment.subDepartments[index].name == '') {
        this.currentDepartment.subDepartments.splice(index, 1)
        return
      }

      const subDepartment = this.currentDepartment.subDepartments[index]
      this.currentDepartment.subDepartments.splice(index, 1)
      this.isEditing = true

      if (subDepartment.id)
        this.apiService
          .delete(`department/subdepartment/delete/${subDepartment.id}`)
          .then(() => {
            this.searchDepartment()
          })
    },

    async getUnidades() {
      let url = 'unidade/list'

      if (this.institutionId) {
        url = `unidade/list/${this.institutionId}`
      }

      await this.apiService.get(url).then((response) => {
        this.unidades = response.content
      })
    },

    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$router.go(-1)
      }
    },

    closeDialog() {
      this.changedData = false
      this.alterDialog = false
      this.close()
    },

    callConfirmDialog() {
      if (this.isEditing && this.$refs.firstForm.validate()) {
        this.confirmDialog = true
      } else {
        this.submit()
      }
    },

    async importExcelFile() {
      var reader = new FileReader()
      reader.readAsDataURL(this.file)
      reader.onload = () => {
        this.data = reader.result
        const fileModel = {
          File: this.data,
          InstitutionId: this.institutionId,
        }

        this.apiService.post('department/import', fileModel).then(() => {})
      }
    },

    showSuccessAlert(message) {
      this.message = message
      this.showSuccess = true

      setTimeout(() => {
        this.showSuccess = false
      }, 1000)
    },

    deleteDepartment(i) {
      this.deletedDepartment = this.departments[i]

      this.deleteDialog = true
    },

    activeDepartment(i) {
      try {
        this.isEditing = true
        this.currentDepartment = this.departments[i]
        this.currentDepartment.status = 0
        this.submit()
      } catch (er) {
        console.log(er)
      }
    },

    async searchDepartment() {
      this.departmentLoading = true
      const filter = {
        institutionId: this.institutionId,
        unityId: this.unidadeId,
        departmentName: this.departmentName,
      }
      if (this.active) {
        await this.apiService
          .post(`department/listActiveFiltered`, filter)
          .then((response) => {
            this.departments = response.content

            this.departmentLoading = false
          })
      } else {
        await this.apiService
          .post(`department/listInactiveFiltered`, filter)
          .then((response) => {
            this.departments = response.content

            this.departmentLoading = false
          })
      }
    },

    async searchDepartmentExcel() {
      this.departmentLoading = true
      const filter = {
        institutionId: this.institutionId,
        unityId: this.unidadeId,
        departmentName: this.departmentName,
      }
      if (this.active) {
        await this.apiService
          .post(`department/listActiveFiltered/Excel`, filter)
          .then((response) => {
            var excelResult = `data:application/octet-stream;base64,${response.content}`
            const link = document.createElement('a')
            link.href = excelResult
            link.setAttribute('download', 'setores.xlsx')
            document.body.appendChild(link)
            link.click()
            this.departmentLoading = false
          })
      } else {
        await this.apiService
          .post(`department/listInactiveFiltered/Excel`, filter)
          .then((response) => {
            var excelResult = `data:application/octet-stream;base64,${response.content}`
            const link = document.createElement('a')
            link.href = excelResult
            link.setAttribute('download', 'setores.xlsx')
            document.body.appendChild(link)
            link.click()
            this.departmentLoading = false
          })
      }
    },

    selectedDepartment() {
      const department = this.departments.find(
        (department) => department.id === this.departmentId
      )

      if (department.id > 0) {
        this.isEditing = true
        this.currentDepartment = department
        this.status = department.status == 0
        this.applyRules = true
      } else {
        this.currentDepartment = {
          subDepartments: [],
        }
        this.isEditing = false
      }
    },

    async addDepartment() {
      if (!this.$refs.addForm.validate()) {
        return
      }
      this.currentDepartment = {
        id: this.newDepartment.id,
        institutionId: this.institutionId,
        unidadeId: this.newDepartment.unidadeId,
        name: this.newDepartment.name,
        initials: this.newDepartment.initials,
        subDepartments: this.newDepartment.subDepartments,
        status: this.newDepartment.status,
      }
      await this.submit()
    },

    setInitialDepertment() {
      this.applyRules = false
      this.departmentId = 0
      this.currentDepartment = null
    },

    async submit() {
      this.loading = true
      this.confirmDialog = false

      let url = 'department/add'

      if (this.isEditing) {
        url = 'department/edit'

        const notAdded = this.newDepartment.subDepartments.find((x) => !x.id)

        if (notAdded) {
          this.$toast.warning(
            'Parece que há um sub-setor com inserção pendente na sua lista de sub-setores, adicione-o para prosseguir'
          )
          return
        }
      }

      console.log(this.currentDepartment)
      await this.apiService
        .post(url, this.currentDepartment)
        .then((response) => {
          url == 'department/edit'
            ? this.$toast.success(this.$t('Setor atualizado!'))
            : this.$toast.success(this.$t('Setor criado com sucesso!'))
          this.loading = false
          this.setInitialDepertment()
          this.searchDepartment()
          this.showSuccessAlert(response.message)
          this.currentDepartment = null
          this.loading = false
          this.isEditing = false
          this.applyRules = true
          this.addDialog = false
          this.currentDepartment = null
          this.newDepartment = {
            Name: null,
            initials: null,
            unidadeId: null,
            subDepartments: [],
          }
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true
          this.loading = false
          this.isEditing = false
          this.applyRules = true
          this.addDialog = false
          this.currentDepartment = null
          this.newDepartment = {
            Name: null,
            initials: null,
            unidadeId: null,
            subDepartments: [],
          }

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async remove() {
      this.deleteLoading = true
      const payload = {
        departmentId: this.deletedDepartment.id,
        userId: this.userId,
      }
      await this.apiService
        .delete('department/delete', payload)
        .then((response) => {
          this.setInitialDepertment()
          this.searchDepartment()
          this.showSuccessAlert(response.message)
          this.deleteDialog = false
          this.deleteLoading = false
        })
        .catch((error) => {
          this.$toast.error(error.message)

          setTimeout(() => {
            this.error = false
          }, 4000)
          this.deleteLoading = false
          this.deleteDialog = false
        })
      this.isEditing = false
      this.applyRules = true
    },
  },

  computed: {
    buttonText() {
      if (this.isEditing) {
        return 'Atualizar'
      } else {
        return 'Adicionar'
      }
    },
  },

  watch: {
    currentDepartment: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },
  },
}
